import React from "react";
import Input from "../../../../components/ui/Input";
import { UserEducationInput } from "../../../../models/employee";
import { DatePicker as CustomDatePicker } from '../../../../components/dateTimePickers';

type EducationFormProps = {
    educationInput: UserEducationInput;
    setEducationInput: (input: UserEducationInput) => void;
    loading: boolean;
    t: any;
};

const EducationForm: React.FC<EducationFormProps> = ({ educationInput, setEducationInput, loading, t }) => {
    return (
        <div className="flex flex-col gap-2.5">
            <Input
                autoFocus
                label={t("Institution Name")}
                type="text"
                value={educationInput.institutionName}
                onChange={(e) => setEducationInput({ ...educationInput, institutionName: e.target.value })}
            />
            <Input
                label={t("Degree")}
                type="text"
                value={educationInput.degree}
                onChange={(e) => setEducationInput({ ...educationInput, degree: e.target.value })}
            />
            <Input
                label={t("Field of Study")}
                type="text"
                value={educationInput.fieldOfStudy}
                onChange={(e) => setEducationInput({ ...educationInput, fieldOfStudy: e.target.value })}
            />
            <CustomDatePicker
                label={t("Start Date")}
                value={educationInput.startDate ? (educationInput.startDate) : null}
                onChange={(date) => setEducationInput({ ...educationInput, startDate: date ?? undefined })}
            />
            <CustomDatePicker
                label={t("End Date")}
                value={educationInput.endDate ? (educationInput.endDate) : null}
                onChange={(date) => setEducationInput({ ...educationInput, endDate: date ?? undefined })}
            />
            <Input
                label={t("Grade")}
                type="text"
                value={educationInput.grade}
                onChange={(e) => setEducationInput({ ...educationInput, grade: e.target.value })}
            />
        </div>
    );
};

export default EducationForm;
